/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Component, ElementRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { UiSelect } from '../../ui-select/ui-select';
import { Filterable } from '../../../mixins/Filterable';
import { Mixin } from '../../../mixins/Mixin';

@Component({
    selector: 'fe-select',
    template: require('./fe-select.html'),
    styles: [
        require('./fe-select.less')
    ],
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: FeSelect, multi: true}
    ]
})
@Mixin([Filterable])
export class FeSelect extends UiSelect {

    @Input() public flex: boolean;
    @Input() innerCentered: boolean = false;

    constructor(public elementRef: ElementRef) {
        super(elementRef);
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/form-elements/fe-select/fe-select.ts